import EST from '@/assets/icon/countries/EST.svg';
import FRN from '@/assets/icon/countries/FRN.png';
import GBR from '@/assets/icon/countries/GBR.svg';
import LV from '@/assets/icon/countries/LAT.svg';
import LT from '@/assets/icon/countries/LT.png';
import RUS from '@/assets/icon/countries/RUS.png';
import SVK from '@/assets/icon/countries/SVK.svg';

import { ENABLED_LANGUAGES } from '@/utils/constants';

import ee from './locales/ee/ee';
import en from './locales/en/en';
import fr from './locales/fr/fr';
import lt from './locales/lt/lt';
import lv from './locales/lv/lv';
import rus from './locales/rus/rus';
import sl from './locales/sl/sl';

export const resources = {
  en: { translation: en },
  fr: { translation: fr },
  ee: { translation: ee },
  lt: { translation: lt }, // Lithuanian
  lv: { translation: lv }, // Latvian
  rus: { translation: rus },
  ru: { translation: rus },
  sl: { translation: sl }, // Slovak
  sv: { translation: sl }, // Slovak
};

export const enabledLanguages = ENABLED_LANGUAGES?.split(',') || ['en'];
export const countryFlagByName = (name: (typeof enabledLanguages)[number]) => {
  switch (name.toLowerCase()) {
    case 'ee':
    case 'es':
      return EST;
    case 'lt':
      return LT;
    case 'lv':
      return LV;
    case 'sl':
    case 'sv':
      return SVK;
    case 'rus':
    case 'ru':
      return RUS;
    case 'fr':
      return FRN;
    case 'en':
    default:
      return GBR;
  }
};

export const DEFAULT_LANGUAGE = 'en';
export const DEFAULT_LANGUAGE_TRANSLATION =
  resources[DEFAULT_LANGUAGE].translation;

export type TFunc = (key: string) => string;
export type tKeysUnion = keyof typeof DEFAULT_LANGUAGE_TRANSLATION;
export type tKeysType = { [key in tKeysUnion]: tKeysUnion };
export const tKeys = Object.fromEntries(
  Object.keys(DEFAULT_LANGUAGE_TRANSLATION).map((key) => [key, key])
) as tKeysType;
